export default __webpack_public_path__ + "static/media/team-photo-2010.29744a14.jpg";